'use client';

import React, { useState } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { SUPPORTED_LANGUAGES } from '@/lib/i18n';
import { ChevronDown } from 'lucide-react';

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const current = SUPPORTED_LANGUAGES?.find(l => l?.code === language) || SUPPORTED_LANGUAGES?.[0];

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(v => !v)}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-border bg-muted hover:border-primary/40 transition-all text-sm font-medium text-foreground"
      >
        <span>{current?.flag}</span>
        <span className="hidden sm:inline">{current?.label}</span>
        <ChevronDown size={14} className={`text-muted-foreground transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 z-50 rounded-xl border border-border bg-card shadow-xl overflow-hidden min-w-[140px]">
          {SUPPORTED_LANGUAGES?.map(lang => (
            <button
              key={lang?.code}
              onClick={() => { setLanguage(lang?.code); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-4 py-2.5 text-sm transition-colors hover:bg-muted ${
                language === lang?.code ? 'text-primary font-semibold bg-primary/5' : 'text-foreground'
              }`}
            >
              <span>{lang?.flag}</span>
              <span>{lang?.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
